import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { postPos, updatePos, showPos } from "../../../../MyApi/pos";
import { toast } from "react-toastify";
import EnhancedSearchStore from "../../../UI/enhancedstoresearch";

const PosModal = ({ show, onClose, refetch, mode, id }) => {
  const [formData, setFormData] = useState({
   name: "",
    store_id: "",
    identifier:"",
    is_active: 1,
  });

  const { data: posData, isLoading: posLoading, refetch: refetchPos } = useQuery(
    ["pos", id],
    () => showPos(id),
    {
      enabled: mode === "edit" && !!id && show,
    }
  );

  useEffect(() => {
    if (mode === "edit" && posData?.data) {
      const pos = posData.data.terminal;
      setFormData({
        name: pos.name || "",
        store_id: pos.store_id || "",
        is_active: pos.is_active || 1,
        identifier:pos.identifier ,
        store_name :pos.store_name
      });
    } else if (mode === "add") {
      setFormData({
        device_name: "",
        store_id: "",
        is_active: 1,
      });
    }
  }, [mode, posData, show]);

  useEffect(() => {
    if (show && mode === "edit" && id) {
      refetchPos();
    }
  }, [show, mode, id, refetchPos]);

  const mutation = useMutation({
    mutationKey: mode === "edit" ? ["updatePos", id] : ["postPos"],
    mutationFn: (postData) => mode === "edit" ? updatePos(postData, id) : postPos(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
      onClose("pos");
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    mutation.mutate(formData);
  };
const setStoreId =(id)=>{
    setFormData((prev) => ({ ...prev, store_id: id }));
}
  const isReadOnly = mode === "show";

  return (
    <Modal isOpen={show} className="add">
      <ModalBody>
        <h5 className="fw-bold">
          {mode === "edit" ? "تعديل نقطة البيع" : mode === "show" ? "عرض نقطة البيع" : "إضافة نقطة البيع"}
        </h5>

        <div className="row">
          <div className="col-12">
            <label htmlFor="" className="form-label">اسم الجهاز</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              disabled={isReadOnly}
            />
          </div>
          <div className="col-12">
            <label htmlFor="" className="form-label">معرف المتجر</label>
            <input
              type="text"
              name="identifier"
              className="form-control"
              value={formData.identifier}
              onChange={handleChange}
              disabled={isReadOnly}
            />
          </div>

          <div className="col-12">
            <label htmlFor="" className="form-label">المتاجر</label>
            <EnhancedSearchStore  setStoreId={setStoreId} value={mode ==="edit"?{id:formData.id ,name:formData.store_name
            }:null}/>
          </div>
          <div className="col-12">
            <label className="form-label">الحالة</label>
            <select
              name="is_active"
              className="form-select"
              value={formData.is_active}
              onChange={handleChange}
              disabled={isReadOnly}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>
        </div>
        <div className="d-flex gap-2 mt-3">
          {!isReadOnly && (
            <button className="btn btn-primary" onClick={handleSubmit} disabled={mutation.isLoading }>
              {mutation.isLoading  ? <Spinner /> : "تأكيد"}
            </button>
          )}
          <button className="btn btn-white" onClick={() => onClose("pos")}>
            {isReadOnly ? "إغلاق" : "إلغاء"}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PosModal;
